import { observable, action, computed, toJS, makeObservable } from "mobx";
import moment from "moment";
import {FieldDescriptors, FieldType} from "../../util/urlSync";

export const today = moment().startOf("day");

export const dateRanges = [
  { count: 7, name: "Last Week", id: 'Last7Days', dateRangeType: "week" },
  { count: 30, name: "Last Month", id: 'Last30Days', dateRangeType: "month" },
  { count: 90, name: "Last 3 Months", id: 'Last3Months', dateRangeType: "3months" },
  { count: 183, name: "Last 6 Months", id: 'Last6Months', dateRangeType: "6months" },
  { count: 365, name: "Last Year", id: 'Last12Months', dateRangeType: "year" },
].map(({ count, name, id, dateRangeType }) => {
  return {
    from: moment(today).subtract(count, "days").startOf("day"),
    to: today.endOf("day"),
    id,
    name,
    dateRangeType,
  };
});

const last3months = dateRanges.find(x => x.dateRangeType === "3months");

export const urlQueryDefinition = FieldDescriptors.build({
  groupId: FieldType.string,
  localSearchAnalyticsProvider: FieldType.string,
  startDate: FieldType.dateString("YYYY-MM-DD"),
  endDate: FieldType.dateString("YYYY-MM-DD"),
  showGroups: FieldType.bool,
  providers: FieldType.delimitedArrayOf(FieldType.string),
});

class ListingFiltersStore {
  state = {
    providers: [],
    localSearchAnalyticsProvider: undefined,
    startDate: last3months.from.format("YYYY-MM-DD"),
    endDate: last3months.to.format("YYYY-MM-DD"),
    showGroups: false
  };

  constructor() {
    makeObservable(this, {
      state: observable,
      setState: action
    });
  }

  setState(updates, callback) {
    Object.assign(this.state, updates);
    callback && callback();
  }
}

const listingFiltersStore = new ListingFiltersStore();

export default listingFiltersStore;